import React from "react";
import {useRef, useState} from "react";
import {useEffect} from "react";
import quiz from "./App.css";
import img from "../src/quiz.data.json";
import axios from "axios";
import Myinput from "./quizInput";
import {Page, Text, View, Document, StyleSheet, pdf, Image, Font, Link} from "@react-pdf/renderer";
import {saveAs} from "file-saver";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import S3 from "aws-sdk/clients/s3";

const Quiz = () => {
	const [datas, setData] = useState(null);
	const [inde, setIndex] = useState(1);
	const [scores, setScore] = useState(null);
	const [show, setShow] = useState(false);
	const [result, setResult] = useState(false);
	const [landing, setLanding] = useState(true);
	const effectRan = useRef(false);

	// const handleResize = () => {
	//   let vh = window.innerHeight;
	//   document
	//     .getElementById("heightContainer")
	//     .style.setProperty("height", `${vh}px`);
	// };

	useEffect(() => {
		if (effectRan.current === false) {
			let vh = window.innerHeight;
			let vw = window.innerWidth;
			if (vw <= 991) {
				document.getElementById("heightContainer").style.setProperty("height", `${vh}px`);
			}
			fetch("https://9txyo3dmie.execute-api.us-east-1.amazonaws.com/dev/questions")
				.then(res => res.json())
				.then(data => {
					setData(data.body);
					document.getElementById("findout").style.pointerEvents = "unset";
					setLanding(true);
				});
			//window.addEventListener("resize", handleResize());
			return () => {
				effectRan.current = true;
				// window.removeEventListener("resize", handleResize());
			};
		}
	}, []);

	const find = event => {
		setLanding(false);
		setShow(true);
		document.getElementById("logo_image").src = "/logo.png";
		setTimeout(() => {
			if (document.getElementById("minus")) {
				// document.getElementById("minus").classList.add("quizdisableMinus");
				// document.getElementById("plus").classList.add("quizdisablePlus");
				let cInput = document.getElementsByName("contactinput");
				for (var i = 0; i < cInput.length; i++) {
					cInput[i].addEventListener("input", handlearrow1);
				}
			}
		}, 1000);
	};
	const notification = async (e, name_up) => {
		let value = JSON.parse(e);
		console.log(value);
		let s3link = "https://vajro-quiz.s3.amazonaws.com/" + name_up;
		const webhookUrl =
			"https://hooks.slack.com/services/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";

		let quizLink = "";
		try {
			const quizData = {
				name: value.name,
				email: value.email,
				phone: value.phone,
				Shopify: value.Shopify,
				s3link,
				score: value.score,
				quizResponse: value.quizResponse,
			};

			quizLink = await axios.post("https://cron.vajro.com/api/v1/quiz/leads", quizData);
		} catch (error) {
			console.log("CRM data push error");
		}

		quizLink =
			quizLink.data.quizLeadLink ||
			"https://one.zoho.in/zohoone/vajroinc/home/cxapp/crm/org60014134902/tab/CustomModule18/";

		const data = {
			text: `*Name* : ${value.name} \n *Email* : ${value.email} \n *Phone* : ${value.phone} \n *Shopify URL* : ${value.Shopify} \n *Pdf link* : <${s3link} | PDF Link>\n *CRM Quiz Lead Link* : <${quizLink} | Lead Link>`,
		};

		let res = await axios.post(webhookUrl, JSON.stringify(data), {
			withCredentials: false,
			transformRequest: [
				(data, headers) => {
					return data;
				},
			],
		});
		console.log(res);
		if (res.status === 200) {
			console.log("");
		} else {
			console.log("There was an error.  Please try again later.");
		}
	};
	const s3 = new S3({
		accessKeyId: "AKIATTFXEDPLOOHU66HO",
		secretAccessKey: "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",
		signatureVersion: "v4",
	});
	const config = {
		api: {
			bodyParser: {
				sizeLimit: "8mb", // Set desired value here
			},
		},
	};
	const getImageSignedUrl = async function (name_up, fileType, file, Email, UserName) {
		const promiseAwait = new Promise(async (resolve, reject) => {
			const fileParams = {
				Bucket: "vajro-quiz",
				Key: name_up,
				Expires: 60,
				ContentType: fileType,
			};
			resolve(await s3.getSignedUrlPromise("putObject", fileParams));
		});
		const result = await promiseAwait;
		if (result) {
			const url = result;
			let {data: newData} = await axios.put(url, file, {
				headers: {
					"Content-type": file.type,
					"Access-Control-Allow-Origin": "*",
				},
			});
			mail(Email, UserName, name_up);
		}
	};
	const mail = (Email, UserName, name_up) => {
		const options = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				toemail: Email,
				ccemail: Email,
				url: "https://vajro-quiz.s3.amazonaws.com/" + name_up,
				user_name: UserName,
				organization: "Vajro",
			}),
		};
		fetch("https://9txyo3dmie.execute-api.us-east-1.amazonaws.com/dev/sendemail", options)
			.then(response => {
				if (!response.ok) {
					throw new Error(`HTTP error: ${response.status}`);
				}
				return response.json();
			})
			.catch(err => console.error(`Fetch problem: ${err.message}`));
	};
	const pdfdownload = async deta => {
		//Removerd Email
		let jsonddatas = localStorage.getItem("Jsondata");
		var Email = localStorage.getItem("email");
		var UserName = localStorage.getItem("userName");
		localStorage.removeItem("email");
		localStorage.removeItem("userName");
		const blob = await pdf(<MyDoc detail={deta} />).toBlob();
		let file = blob;
		// saveAs(blob, "Survey Result.pdf");
		let name_up = Email.replace(/[^\w\s]/gi, "") + Math.round(Math.random() * Math.pow(10, 8));
		let fileType = file.type;
		notification(jsonddatas, name_up);
		getImageSignedUrl(name_up, fileType, file, Email, UserName);
	};

	function facebookAnalytics() {
		let utmParams = new URL(window.location.toLocaleString()).searchParams;
		const utm_source = utmParams.get("utm_source");
		const utm_medium = utmParams.get("utm_medium");
		if (utm_source && utm_medium) {
			window.fbq("track", "Quiz_CTA", {
				utm_source: utm_source,
				utm_medium: utm_medium,
			});
		}
	}

	function googleAnalytics(email, url) {
		let utmParams = new URL(window.location.toLocaleString()).searchParams;
		const utm_source = utmParams.get("utm_source");
		const utm_medium = utmParams.get("utm_medium");
		if (utm_source) {
			window.gtag("event", "quiz_complete_paid", {
				quiz_complete_paid_email_id: email,
				quiz_complete_paid_url: url,
			});
		}
	}

	const submit = event => {
		var answer_details = [];
		var childElements = document.getElementById("main").children;
		for (var forElem = 0; forElem < childElements.length; forElem++) {
			if (forElem < childElements.length - 3) {
				var qId = datas[0].questions[forElem].id;
				var content_num = datas[0].questions[forElem].content;
				var Type = datas[0].answers[forElem].type;
				var inp = childElements[forElem].querySelectorAll("input");
				var choice = [];
				for (var jj = 0; jj < inp.length; jj++) {
					if (inp[jj].checked) {
						var answerId = inp[jj].name;
						var choiseId = inp[jj].id;
						var label = document.getElementsByName(answerId)[jj].nextSibling.innerText;
						var content_text_ans =
							content_num == "1" ? datas[0].answers[forElem].choice[jj].content_text : "";
						var scr = datas[0].answers[forElem].choice[jj].score;
						if (content_num == "1") {
							choice.push({
								choise_id: answerId,
								content_text: content_text_ans,
								value: label,
								score: scr,
							});
						} else {
							choice.push({choise_id: choiseId, value: label, score: scr});
						}
					}
				}
				answer_details.push({
					q_id: qId,
					type: Type,
					content: content_num,
					choices: choice,
				});
			} else {
				var val = childElements[forElem].querySelectorAll("input")[0].value;
				var nam = childElements[forElem].querySelectorAll("input")[0].type;
				switch (nam) {
					case "url":
						answer_details.push({user_name: val});
						localStorage.setItem("userName", val.replace(/.+\/\/|www.|\..+/g, ""));
						break;
					case "tel":
						answer_details.push({Phone: val});
						break;
					case "email":
						answer_details.push({Email: val});
						localStorage.setItem("email", val);
						break;
				}
			}
		}
		var obj = {answer_details: answer_details};
		console.log(obj);

		function questionandAnswers(obj) {
			const questionAnswerPairs = [];

			for (let i = 0; i < obj.answer_details.length; i++) {
				if (obj.answer_details[i].q_id) {
					let answers = [];
					let question = obj.answer_details[i].q_id;

					obj.answer_details[i].choices.forEach(choice => {
						answers.push({
							choice_id: choice.choise_id,
							choice: choice.value,
						});
					});

					questionAnswerPairs.push({
						question: question,
						answers: answers,
					});
				}
			}

			return questionAnswerPairs;
		}

		const options = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(obj),
		};

		let scorevalue = 0;
		localStorage.setItem("storeTypedata", answer_details[2].choices[0].value);
		fetch("https://9txyo3dmie.execute-api.us-east-1.amazonaws.com/dev/score", options)
			.then(res => res.json())
			.then(data => {
				setScore(data);
				setShow(false);
				setResult(true);

				scorevalue = data.score;
				var questionAndAnswerResponse = questionandAnswers(obj);
				console.log(questionAndAnswerResponse);
				var jsondata = JSON.stringify({
					name: answer_details[answer_details.length - 3].user_name.replace(/.+\/\/|www.|\..+/g, ""),
					email: answer_details[answer_details.length - 1].Email,
					phone: answer_details[answer_details.length - 2].Phone,
					Shopify: answer_details[answer_details.length - 3].user_name,
					storeType: answer_details[2].choices[0].value,
					score: scorevalue,
					quizResponse: questionAndAnswerResponse,
				});

				localStorage.setItem("Jsondata", jsondata);

				pdfdownload(data);
				let user_emailID = answer_details[answer_details.length - 1].Email;
				let user_ShopifyURL = answer_details[answer_details.length - 3].user_name;
				facebookAnalytics();
				googleAnalytics(user_emailID, user_ShopifyURL);

				axios
					.post("https://api.apispreadsheets.com/data/sVEL0hi3ciuUEkaE/", jsondata)
					.then(response => {
						console.log();
					})
					.catch(error => {
						console.log(error);
					});
			});

		// notification(name, email, phone)
	};
	const radionext = event => {
		if (!event) {
			setTimeout(() => {
				plus();
			}, 500);
		}
	};
	const plus = event => {
		let ele = document.getElementById("main").children;
		if (inde < ele.length) {
			for (var f = 0; f < ele.length; f++) {
				if (f === inde) {
					document.getElementById("main").children[f].style.display = "block";
				} else {
					document.getElementById("main").children[f].style.display = "none";
				}
			}
			if (inde < ele.length) {
				document.getElementById("minus").classList.remove("quizdisableMinus");
				setIndex(inde + 1);
			}
			if (inde == ele.length - 1) {
				document.getElementById("plus").style.display = "none";
				document.getElementById("submit").style.display = "block";
				document.getElementById("submit").classList.add("quizdisablePlus");
			}
			if (inde >= ele.length) {
				setIndex(inde);
			}
		}
		var eleme = document.getElementsByName("answer");
		var t = 0;
		for (var f = 0; f < eleme.length; f++) {
			if (eleme[f].style.display == "block") {
				var ffff = eleme[f].querySelectorAll("input");
				for (var fd = 0; fd < ffff.length; fd++) {
					if (ffff[fd].checked) {
						t = t + 1;
						ffff[fd].style.animation = "unset";
					}
					if (
						ffff[fd].value != "" &&
						(ffff[0].type == "text" || ffff[0].type == "email" || ffff[0].type == "tel")
					) {
						t = t + 1;
					}
				}
			}
		}
		if (t > 0) {
			document.getElementById("plus").classList.remove("quizdisablePlus");
			document.getElementById("submit").classList.remove("quizdisablePlus");
		} else {
			document.getElementById("plus").classList.add("quizdisablePlus");
			document.getElementById("submit").classList.add("quizdisablePlus");
		}
	};
	const minus = event => {
		let ele = document.getElementById("main").children;
		if (inde == ele.length) {
			document.getElementById("plus").style.display = "block";
			document.getElementById("submit").style.display = "none";
		}
		if (inde > 1) {
			for (var e = 0; e < ele.length; e++) {
				document.getElementById("main").children[e].style.display = "none";
			}
			document.getElementById("main").children[inde - 2].style.display = "block";
			if (inde == 2) {
				document.getElementById("minus").classList.add("quizdisableMinus");
				setIndex(1);
			} else {
				document.getElementById("plus").classList.remove("quizdisablePlus");
				setIndex(inde - 1);
			}
		}
		var eleme = document.getElementsByName("answer");
		var t = 0;
		for (var f = 0; f < eleme.length; f++) {
			if (eleme[f].style.display == "block") {
				var ffff = eleme[f].querySelectorAll("input");
				for (var fd = 0; fd < ffff.length; fd++) {
					if (ffff[fd].checked) {
						t = t + 1;
						ffff[fd].style.animation = "unset";
					}
					if (ffff[fd].value != "") {
						t = t + 1;
					}
				}
			}
		}
		if (t > 0) {
			document.getElementById("plus").classList.remove("quizdisablePlus");
		} else {
			document.getElementById("plus").classList.add("quizdisablePlus");
		}
	};
	const handlearrow = event => {
		if (event.target.type == "checkbox") {
			var eve = event.target.parentElement.parentElement.querySelectorAll("input");
			var tr = 0;
			for (var r = 0; r < eve.length; r++) {
				if (eve[r].checked) {
					tr = tr + 1;
				}
			}
			if (tr > 0) {
				document.getElementById("plus").classList.remove("quizdisablePlus");
			} else {
				document.getElementById("plus").classList.add("quizdisablePlus");
			}
		} else if (event.target.type == "radio") {
			document.getElementById("plus").classList.remove("quizdisablePlus");
		}
	};
	const handlearrow1 = event => {
		if (event.target.value != "") {
			switch (event.target.type) {
				case "email":
					const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/;
					if (mailformat.test(event.target.value)) {
						document.getElementById("plus").classList.remove("quizdisablePlus");
						document.getElementById("submit").classList.remove("quizdisablePlus");
						document.getElementById("emaillabel").style.display = "none";
					} else {
						document.getElementById("emaillabel").style.display = "block";
						document.getElementById("plus").classList.add("quizdisablePlus");
						document.getElementById("submit").classList.add("quizdisablePlus");
					}
					break;
				case "tel":
					var re = /\(?\+?\d{1,4}?\)?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/g;
					if (re.test(event.target.value)) {
						document.getElementById("plus").classList.remove("quizdisablePlus");
						document.getElementById("submit").classList.remove("quizdisablePlus");
					} else {
						document.getElementById("plus").classList.add("quizdisablePlus");
						document.getElementById("submit").classList.add("quizdisablePlus");
					}
					break;
				case "url":
					var webreg = /^(https?:\/\/)?[a-zA-Z0-9][a-zA-Z0-9-]*.myshopify.com/;
					if (webreg.test(event.target.value)) {
						document.getElementById("plus").classList.remove("quizdisablePlus");
						document.getElementById("submit").classList.remove("quizdisablePlus");
					} else {
						document.getElementById("plus").classList.add("quizdisablePlus");
						document.getElementById("submit").classList.add("quizdisablePlus");
					}
					break;
				default:
					document.getElementById("plus").classList.remove("quizdisablePlus");
					document.getElementById("submit").classList.remove("quizdisablePlus");
			}
		} else {
			document.getElementById("plus").classList.add("quizdisablePlus");
			document.getElementById("submit").classList.add("quizdisablePlus");
		}
	};
	const styles = StyleSheet.create({
		page: {
			backgroundColor: "#FFF",
		},
		logosection: {
			paddingTop: 30,
			paddingLeft: 30,
			backgroundColor: "#F62369",
		},
		section: {
			paddingTop: 50,
			padding: 30,
			backgroundColor: "#F62369",
			height: 300,
			flexDirection: "row",
			color: "#fff",
			marginBottom: 50,
		},
		Bsection: {
			height: 170,
			display: "flex",
			flexDirection: "row",
			alignItems: "center",
			color: "#000",
			borderBottom: "1 solid #000",
			marginLeft: 50,
			marginRight: 50,
		},
		BsectionFirst: {
			height: 200,
			display: "flex",
			flexDirection: "row",
			alignItems: "center",
			color: "#000",
			borderBottom: "1 solid #000",
			marginLeft: 50,
			marginRight: 50,
		},
		Bsectionlast: {
			height: 170,
			display: "flex",
			flexDirection: "row",
			alignItems: "center",
			color: "#000",
			marginLeft: 50,
			marginRight: 50,
		},
		logo: {
			height: 34,
			width: 100,
		},
		sectionImage: {
			width: 250,
			height: 250,
			flexDirection: "column",
			textAlign: "center",
			justifyContent: "space-between",
			position: "relative",
		},
		BsectionImage: {
			width: 250,
			height: 200,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			flexDirection: "column",
			textAlign: "center",
		},
		sectionText: {
			width: 250,
			height: 250,
			textAlign: "left",
			justifyContent: "center",
			fontFamily: "Poppins Regular",
			paddingLeft: 30,
			marginLeft: 20,
		},
		bsectionText: {
			width: 250,
			fontFamily: "Poppins Regular",
			textAlign: "left",
			justifyContent: "center",
		},
		sectionText11: {
			fontSize: 20,
			color: "#000",
			fontFamily: "Poppins Regular",
			marginLeft: 85,
			position: "absolute",
			top: "155",
		},
		sectionText0: {
			fontSize: 30,
			color: "#F62369",
			marginLeft: 90,
			position: "absolute",
			fontFamily: "Poppins Regular",
			top: "180",
			fontWeight: "500",
		},
		sectionText1: {
			fontSize: 17,
			fontFamily: "Poppins Bold",
			fontWeight: "ultrabold",
			color: "#fff",
			marginBottom: 25,
		},
		sectionText2: {
			fontSize: 12,
			color: "#fff",
		},
		BsectionText1: {
			fontSize: 17,
			fontFamily: "Poppins Bold",
			fontWeight: "800",
			color: "#000",
			marginBottom: 15,
		},
		FootersectionText: {
			fontSize: 17,
			fontFamily: "Poppins Regular",
			fontWeight: "800",
			color: "#fff",
			marginBottom: 25,
			textAlign: "center",
		},
		footersection: {
			paddingTop: 10,
			paddingLeft: 10,
			backgroundColor: "#F62369",
			height: 161,
			display: "flex",
			justifyContent: "center",
			fontFamily: "Poppins Regular",
			alignItems: "center",
		},
		FootersectionLink: {
			color: "#000",
			backgroundColor: "#fff",
			height: "40",
			width: "200",
			textDecoration: "none",
			fontFamily: "Poppins Regular",
			textAlign: "center",
			border: "1 solid #000",
		},
		FooterLinkText: {
			paddingTop: "6",
			fontWeight: "800",
			fontFamily: "Poppins Regular",
		},
		BsectionText2: {
			fontSize: 12,
			color: "#000",
		},
		section1: {
			marginTop: 50,
			padding: 10,
		},
		image: {
			width: 280,
			height: 200,
			marginTop: 30,
			position: "relative",
			zIndex: 1,
		},
		Bimage: {
			width: 150,
			height: 150,
		},
	});
	Font.register({
		family: "Poppins Regular",
		src: "https://cdn.jsdelivr.net/npm/@fontsource/poppins@4.5.10/files/poppins-all-400-normal.woff",
	});
	Font.register({
		family: "Poppins Bold",
		src: "https://cdn.jsdelivr.net/npm/@fontsource/poppins@4.5.10/files/poppins-all-600-normal.woff",
	});
	Font.registerHyphenationCallback(word => [word]);
	const MyDoc = detail => {
		let jsonddata = localStorage.getItem("storeTypedata");
		let firstText;
		switch (jsonddata) {
			case "Fashion and apparel":
				firstText = "Your fashion store and a mobile app will make a kickass combo!";
				break;
			case "Food and Beverage":
				firstText = "Mobile apps work incredibly well for F&B stores";
				break;
			case "Sporting goods":
				firstText = "Offering a mobile app would boost your store's engagement!";
				break;
			case "Pet supplies":
				firstText = "Offering a mobile app would help your increase repeat purchases! ";
				break;
			case "Beauty and wellness":
				firstText = "Your store and a mobile app will make a great combo!";
				break;
			case "Art supplies and hobbies":
				firstText = "Offering a mobile app would boost your store's engagement!";
				break;
			case "Home and gardening supplies":
				firstText = "Offering a mobile app would help your increase repeat purchases! ";
				break;
			case "Dropshippers":
				firstText = "Offering a mobile app would help your increase repeat purchases! ";
				break;
			case "Healthcare and pharma":
				firstText = "Offering a mobile app would help your increase repeat purchases! ";
				break;
			case "Health and Fitness":
				firstText = "Offering a mobile app would boost your store's engagement!";
				break;
			case "Automotive and Vehicles":
				firstText = "Offering a mobile app would help your increase repeat customers! ";
				break;
			case "Electronic Appliances / Technology":
				firstText = "Offering a mobile app would boost your store's engagement!";
				break;
			case "Travel":
				firstText = "Offering a mobile app would boost your store's engagement!";
				break;
			case "Others":
				firstText = "Offering a mobile app would boost your store's engagement!";
				break;
			case "I can’t really say where my store falls (close the face with hand smiley)":
				firstText = "Mobile apps are the way to go to engage better and boost sales!";
				break;
		}
		localStorage.removeItem("storeTypedata");
		localStorage.removeItem("Jsondata");
		return (
			<Document>
				<Page size="A4" style={styles.page}>
					<View style={styles.section}>
						<View style={styles.logosection}>
							<Image style={styles.logo} src="/vajro-inverted.png"></Image>
						</View>
						<View style={styles.sectionImage}>
							<Text style={styles.sectionText11}>Your Score</Text>
							<Text style={styles.sectionText0}>{detail.detail.score}/100</Text>
							<Image
								style={styles.image}
								src="https://res.cloudinary.com/vajrohq/image/upload/v1666958369/marketing/Survey/Asset_7.png"
							/>
						</View>
						<View style={styles.sectionText}>
							<Text style={styles.sectionText1}>Well, what’re you waiting for?</Text>
							<Text style={styles.sectionText2}>
								Your store is missing out on a lot of potential customers and revenue without a mobile app.
								Optimize the shopping experience for your customers with a mobile app and watch your revenue
								& conversion rate grow 3x.
							</Text>
						</View>
					</View>
					<View style={styles.BsectionFirst}>
						<View style={styles.BsectionImage}>
							<Image
								style={styles.Bimage}
								src="https://res.cloudinary.com/vajrohq/image/upload/v1667976724/marketing/Survey/Quiz-high-res-02.png"
							/>
						</View>
						<View style={styles.bsectionText}>
							<Text style={styles.BsectionText1}>{firstText}</Text>
							<Text style={styles.BsectionText2}>{detail.detail.text[0]}</Text>
						</View>
					</View>
					<View style={styles.Bsection}>
						<View style={styles.BsectionImage}>
							<Image
								style={styles.Bimage}
								src="https://res.cloudinary.com/vajrohq/image/upload/v1666962316/marketing/Survey/Quiz-high-res-01.png"
							/>
						</View>
						<View style={styles.bsectionText}>
							<Text style={styles.BsectionText1}>Your customers love your products!</Text>
							<Text style={styles.BsectionText2}>{detail.detail.text[1]}</Text>
						</View>
					</View>
					<View style={styles.Bsection} break>
						<View style={styles.BsectionImage}>
							<Image
								style={styles.Bimage}
								src="https://res.cloudinary.com/vajrohq/image/upload/v1666962316/marketing/Survey/Quiz-high-res-04.png"
							/>
						</View>
						<View style={styles.bsectionText}>
							<Text style={styles.BsectionText1}>That's a lotta engagement!</Text>
							<Text style={styles.BsectionText2}>{detail.detail.text[2]}</Text>
						</View>
					</View>
					<View style={styles.Bsection}>
						<View style={styles.BsectionImage}>
							<Image
								style={styles.Bimage}
								src="https://res.cloudinary.com/vajrohq/image/upload/v1666962316/marketing/Survey/Quiz-high-res-05.png"
							/>
						</View>
						<View style={styles.bsectionText}>
							<Text style={styles.BsectionText1}>Your audience is mobile-ready!</Text>
							<Text style={styles.BsectionText2}>{detail.detail.text[3]}</Text>
						</View>
					</View>
					<View style={styles.Bsection}>
						<View style={styles.BsectionImage}>
							<Image
								style={styles.Bimage}
								src="https://res.cloudinary.com/vajrohq/image/upload/v1666962316/marketing/Survey/Quiz-high-res-06.png"
							/>
						</View>
						<View style={styles.bsectionText}>
							<Text style={styles.BsectionText1}>Your customers love you and your products!</Text>
							<Text style={styles.BsectionText2}>{detail.detail.text[4]}</Text>
						</View>
					</View>
					<View style={styles.Bsectionlast}>
						<View style={styles.BsectionImage}>
							<Image
								style={styles.Bimage}
								src="https://res.cloudinary.com/vajrohq/image/upload/v1667976725/marketing/Survey/Quiz-high-res-07.png"
							/>
						</View>
						<View style={styles.bsectionText}>
							<Text style={styles.BsectionText1}>Social media game on-point!</Text>
							<Text style={styles.BsectionText2}>{detail.detail.text[5]}</Text>
						</View>
					</View>
					<View style={styles.footersection}>
						<Text style={styles.FootersectionText}>Wanna get started with a mobile app?</Text>
						<Link
							style={styles.FootersectionLink}
							src="https://calendly.com/d/wdb8-nbqk/book-a-demo?month=2023-07"
							target="blank"
						>
							<Text style={styles.FooterLinkText}>Book a Demo</Text>
						</Link>
					</View>
				</Page>
			</Document>
		);
	};
	return (
		<div id="heightContainer" className="heightContainer">
			{show ? (
				<>
					<div className="container_wrap">
						<div id="main" className="inner_container">
							{datas[0].questions &&
								datas[0].questions.map((val, ind) => {
									return (
										<div key={ind} name="answer" className="qusAnsDiv">
											<div className="ansImgDiv">
												<div className="imageContainer">
													<div id="quiz_nav" className="navContainer">
														<img
															id="logo_image"
															src="https://quiz-web-flow.s3.amazonaws.com/Vajro pink logo.png"
															alt=""
														></img>
													</div>
													<div className="qnsImages">
														<img key={ind * 2} className="qnsImg" src={img.qnimage[ind]} alt=""></img>
													</div>
												</div>
												<div id="answerDiv" className="answerDiv">
													<div className="question">
														<h3 className="qn">{ind + 1}</h3>
														<h3 className="ques">{val.title}</h3>
														{val.short_text ? <h5 className="shorttext">{val.short_text}</h5> : ""}
														{datas[0].answers[ind].type == "radio" ? (
															""
														) : (
															<h5 className="shorttext1">
																Select all options that apply and click the &gt; next arrow
															</h5>
														)}
													</div>
													<div id="scroll" className="answerDiv1">
														{datas[0].answers[ind].choice.map((ans, i) => {
															return (
																<>
																	<div key={i * 3} id="answerInput" className="answerInput">
																		<Myinput
																			childToParent={datas[0].answers[ind].type == "radio" ? radionext : null}
																			name={datas[0].answers[ind].q_id}
																			Key={i}
																			Id={ans.id}
																			Type={datas[0].answers[ind].type}
																		></Myinput>
																		<label name={ans.id} className="label" key={i + 1} htmlFor={ans.id}>
																			{ans.label}
																		</label>
																	</div>
																</>
															);
														})}
													</div>
												</div>
											</div>
										</div>
									);
								})}
							<div name="answer" className="qusAnsDiv">
								<div className="ansImgDiv">
									<div className="DataImageContainer">
										<div id="quiz_nav" className="navContainer">
											<img id="logo_image" src="/logo.png" alt=""></img>
										</div>
										<div className="qnsImages">
											<img
												className="qnsImg"
												src="https://quiz-web-flow.s3.amazonaws.com/quiz/Report.gif"
												alt=""
											></img>
										</div>
									</div>
									<div id="QuizContInput1" className="answerDiv">
										<div className="answerDivInner">
											<h3 className="inputQues">Please enter your complete Shopify store URL</h3>
											<input
												id="contactinput"
												type="url"
												name="contactinput"
												className="contactInput"
												placeholder="Copy & paste your URL"
												required
											></input>
										</div>
									</div>
								</div>
							</div>
							<div name="answer" className="qusAnsDiv">
								<div className="ansImgDiv">
									<div className="DataImageContainer">
										<div id="quiz_nav" className="navContainer">
											<img id="logo_image" src="/logo.png" alt=""></img>
										</div>
										<div className="qnsImages">
											<img
												className="qnsImg"
												src="https://quiz-web-flow.s3.amazonaws.com/quiz/Report.gif"
												alt=""
											></img>
										</div>
									</div>
									<div id="QuizContInput2" className="answerDiv">
										<div className="answerDivInner">
											<h3 className="inputQues">Could you please drop your phone number as well?</h3>
											<PhoneInput
												className="contactPhoneInput"
												placeholder="Country Code + Phone"
												inputProps={{
													name: "contactinput",
													id: "contactinput",
													type: "tel",
												}}
												inputStyle={{
													width: "100%",
													height: "38px",
													border: "none",
												}}
												dropdownStyle={{width: "425px", color: "#000"}}
												buttonStyle={{borderRadius: "25px 0 0 25px"}}
											/>
										</div>
									</div>
								</div>
							</div>
							<div name="answer" className="qusAnsDiv">
								<div className="ansImgDiv">
									<div className="DataImageContainer">
										<div id="quiz_nav" className="navContainer">
											<img id="logo_image" src="/logo.png" alt=""></img>
										</div>
										<div className="qnsImages">
											<img
												className="qnsImg"
												src="https://quiz-web-flow.s3.amazonaws.com/quiz/Report.gif"
												alt=""
											></img>
										</div>
									</div>
									<div id="QuizContInput3" className="answerDiv">
										<div className="answerDivInner">
											<h3 className="inputQues">Where do we send the report?</h3>
											<input
												id="contactinput"
												type="email"
												name="contactinput"
												className="contactInput"
												placeholder="Enter the Email"
												required
											></input>
											<label
												style={{
													textAlign: "center",
													display: "block",
													fontSize: "13px",
													color: "red",
													margin: "10px 0px 0px 0px",
												}}
												id="emaillabel"
											>
												*Please enter a valid email address
											</label>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="footer">
							<button id="minus" onClick={minus} className="quizdisableMinus">
								{/* &lt; */}
							</button>
							<button id="plus" onClick={plus} className="quizdisablePlus">
								{/* &gt; */}
							</button>
							<button id="submit" style={{display: "none"}} onClick={submit}>
								{/* &gt; */}
							</button>
						</div>
					</div>
				</>
			) : (
				""
			)}
			{landing ? (
				<>
					<div className="LandingContainer">
						<div id="LandingleftContainer">
							<img
								id="logo_image"
								className="nav"
								src="https://quiz-web-flow.s3.amazonaws.com/Vajro white logo.png"
								alt=""
							></img>
							<p className="LandingText">
								Hey! Do you know
								<span> how much revenue </span>
								your Shopify store can
								<span> generate with a mobile app?</span>
								<br />
							</p>
							<p className="LandingSubText">
								Take this 3-minute quiz to learn how your Shopify Store could make more revenue with a
								mobile app.
							</p>
							<button id="findout" onClick={find} className="LandingButton">
								Find Out Now
							</button>
						</div>
						<div id="LandingrightContainer">
							<img
								className="landingImage"
								src="https://quiz-web-flow.s3.amazonaws.com/quiz/landing.gif"
							></img>
						</div>
					</div>
				</>
			) : (
				""
			)}
			{result ? (
				<>
					<div className="ansImgDiv1">
						<div className="resultimageContainer">
							<div id="quiz_nav" className="navContainer">
								<img id="logo_image" src="/vajro-inverted.png" alt=""></img>
							</div>
							<div className="result">
								<h3>
									Your Score
									<br /> <span>{scores.score}/100</span>
								</h3>
								<img
									src="https://res.cloudinary.com/vajrohq/image/upload/v1666958823/marketing/Survey/Result-main.png"
									alt=""
								></img>
							</div>
						</div>
						<div className="ButtonDiv">
							<div className="resultContent">
								<h2 className="quiz_thankyou_title">Thank you for taking part in the quiz!</h2>
								<p>
									All done! Thanks for participating in the survey! Your results have been downloaded to your
									device and sent to your inbox.
									<br />
									<br />
									Did you know that a mobile app can help you achieve 10x sales and increase AOV by 40%? A
									mobile app helps you engage better with your customers and even improves their shopping
									experience!
								</p>
							</div>
							<div className="TrailButtonDiv">
								<a href="https://calendly.com/d/wdb8-nbqk/book-a-demo?month=2023-07" target="__blank">
									<button className="ResultButton">Talk to an Expert</button>
								</a>
								<a href="https://apps.shopify.com/vajro" target="__blank">
									<button className="ResultButton">Start Your Free Trial</button>
								</a>
							</div>
						</div>
					</div>
				</>
			) : (
				""
			)}
		</div>
	);
};

export default Quiz;
